import { memo } from "react";

import styles from "./NoData.module.css";

const NoData = memo(function NoData() {
  return <p className={styles["no-data"]}>No data</p>;
});

export default NoData;


